(function () {
  function initSizeGuide() {
    var wrap = document.querySelector('.sg-wrap');
    if (!wrap || wrap.dataset.sgInitialized === 'true') return;
    wrap.dataset.sgInitialized = 'true';

    var GUIDE_CONFIGS = {
      everything: {
        BASE: {
          '32': { A:'S',  B:'S',  C:'S',  D:'S',  DD:'S',  DDD:'M',  DDDD:null },
          '34': { A:'S',  B:'S',  C:'S',  D:'M',  DD:'M',  DDD:'M',  DDDD:'L'  },
          '36': { A:'S',  B:'M',  C:'M',  D:'M',  DD:'M',  DDD:'L',  DDDD:'L'  },
          '38': { A:'M',  B:'M',  C:'M',  D:'L',  DD:'L',  DDD:'L',  DDDD:'XL' },
          '40': { A:'M',  B:'L',  C:'L',  D:'L',  DD:'XL', DDD:'XL', DDDD:'XL' },
          '42': { A:'L',  B:'L',  C:'L',  D:'XL', DD:'XL', DDD:'XL', DDDD:'XL' },
          '44': { A:'L',  B:'XL', C:'XL', D:'XL', DD:'XL', DDD:'XL', DDDD:null },
          '46': { A:null, B:'XL', C:'XL', D:null, DD:null, DDD:null, DDDD:null }
        },
        CUPS: ['A','B','C','D','DD','DDD','DDDD'],
        BANDS: ['32','34','36','38','40','42','44','46']
      },

      'do-anything': {
        BASE: {
          '32': { A:null, B:'S',  C:'S',  D:'S',  DD:'M',  DDD:'M'  },
          '34': { A:null, B:'S',  C:'S',  D:'M',  DD:'M',  DDD:'L'  },
          '36': { A:null, B:'M',  C:'M',  D:'L',  DD:'L',  DDD:'XL' },
          '38': { A:null, B:'M',  C:'L',  D:'XL', DD:'XL', DDD:null },
          '40': { A:null, B:'L',  C:'XL', D:'XL', DD:'XL', DDD:null },
          '42': { A:null, B:'XL', C:'XL', D:null, DD:null, DDD:null }
        },
        CUPS: ['A','B','C','D','DD','DDD'],
        BANDS: ['32','34','36','38','40','42']
      },
      'all-in-panty': {
       type: 'all-in-panty',
       SIZE_MAP: {
         2:'S', 3:'S', 4:'S',
         6:'M', 7:'M', 8:'M',
         10:'L', 11:'L', 12:'L',
         14:'XL', 15:'XL', 16:'XL',
         18:'2XL', 19:'2XL', 20:'2XL',
         22:'3XL', 23:'3XL', 24:'3XL'
  },
  SIZE_ORDER: ['S','M','L','XL','2XL','3XL'],
  SIZE_RANGES: {
    S:'2–4',
    M:'6–8',
    L:'10–12',
    XL:'14–16',
    '2XL':'18–20',
    '3XL':'22–24'
  }
},
'so-easy': {
  BASE: {
    '32': { A:'S', B:'S', C:'S', D:'S', DD:'M', DDD:null },
    '34': { A:'S', B:'S', C:'S', D:'M', DD:'M', DDD:null },
    '36': { A:'M', B:'M', C:'M', D:'L', DD:'L', DDD:'XL' },
    '38': { A:'M', B:'M', C:'M', D:'L', DD:'XL', DDD:null },
    '40': { A:'L', B:'L', C:'L', D:'XL', DD:null, DDD:null },
    '42': { A:'XL', B:'XL', C:'XL', D:null, DD:null, DDD:null }
  },
  CUPS: ['A','B','C','D','DD','DDD'],
  BANDS: ['32','34','36','38','40','42']
},
'always-on-tank': {
  BASE: {
    '32': { A:'S',  B:'S',  C:'S',  D:'S',  DD:'M'  },
    '34': { A:'S',  B:'S',  C:'S',  D:'M',  DD:'M'  },
    '36': { A:'M',  B:'M',  C:'M',  D:'M',  DD:'L'  },
    '38': { A:'M',  B:'M',  C:'M',  D:'L',  DD:'L'  },
    '40': { A:'L',  B:'L',  C:'L',  D:'L',  DD:'XL' },
    '42': { A:'XL', B:'XL', C:'XL', D:'XL', DD:'XL' }
  },
  CUPS: ['A','B','C','D','DD'],
  BANDS: ['32','34','36','38','40','42']
},
      'under-belly-panty': {
        type: 'panty',
        SIZE_MAP: {
          2:'S', 3:'S', 4:'S',
          6:'M', 7:'M', 8:'M',
          10:'L', 11:'L', 12:'L',
          14:'XL', 15:'XL', 16:'XL',
          18:'2XL', 19:'2XL', 20:'2XL',
          22:'3XL', 23:'3XL', 24:'3XL'
        }
      }
    };

    var SIZE_ORDER = ['S','M','L','XL'];

    var guideType = wrap.dataset.guideType || 'everything';
    var guideName = wrap.dataset.guideName || 'Bra';

    var config = GUIDE_CONFIGS[guideType] || GUIDE_CONFIGS.everything;
    var BASE = config.BASE;
    var CUPS = config.CUPS;
    var BANDS = config.BANDS;
    
    if (config.type === 'all-in-panty') {
  var PANTY_SIZE_MAP = config.SIZE_MAP;
  var PANTY_SIZE_ORDER = config.SIZE_ORDER;
  var PANTY_SIZE_RANGES = config.SIZE_RANGES;

  var adjust = 0;
  var activeBtn = null;
  var lastSize = null;

  function shiftPantySize(size, offset) {
    if (!size || offset === 0) return size;
    var i = PANTY_SIZE_ORDER.indexOf(size);
    if (i === -1) return size;
    return PANTY_SIZE_ORDER[Math.max(0, Math.min(PANTY_SIZE_ORDER.length - 1, i + offset))];
  }

  function pantyCellClass(size) {
    var map = {
      S: 'sg-cell-s',
      M: 'sg-cell-m',
      L: 'sg-cell-l',
      XL: 'sg-cell-xl',
      '2XL': 'sg-cell-2xl',
      '3XL': 'sg-cell-3xl'
    };
    return map[size] || 'sg-cell-s';
  }

  function buildAllInPantyTable() {
    var tbody = wrap.querySelector('#sgTbody');
    if (!tbody) return;
    tbody.innerHTML = '';

    var tr = document.createElement('tr');

    var labelTd = document.createElement('td');
    labelTd.className = 'sg-row-label';
    labelTd.innerHTML = 'Pre-Pregnancy<br>Size';
    tr.appendChild(labelTd);

    PANTY_SIZE_ORDER.forEach(function(baseSize) {
      var td = document.createElement('td');
      var displaySize = shiftPantySize(baseSize, adjust);

      td.textContent = PANTY_SIZE_RANGES[displaySize] || '–';
      td.className = pantyCellClass(displaySize);
      td.dataset.size = baseSize;

      if (baseSize === lastSize) {
        td.classList.add('sg-cell-highlight');
      }

      tr.appendChild(td);
    });

    tbody.appendChild(tr);
  }

  function updateAllInPantyStatus() {
    var note = wrap.querySelector('#sgShiftNote');
    var bar = wrap.querySelector('#sgStatusBar');
    if (!note || !bar) return;

    if (adjust === -1) {
      note.textContent = 'Sizes shifted down - postpartum 3+ months, in between sizes.';
      bar.innerHTML = 'Showing: <strong>Sized Down - Postpartum 3+ Months</strong>';
    } else if (activeBtn === 'up1') {
      note.textContent = 'Sizes shifted up - postpartum 0-3 months, in between sizes.';
      bar.innerHTML = 'Showing: <strong>Sized Up - Postpartum 0-3 Months</strong>';
    } else if (activeBtn === 'up2') {
      note.textContent = 'Sizes shifted up - pregnant (3rd trimester or expecting multiples).';
      bar.innerHTML = 'Showing: <strong>Sized Up - Pregnant</strong>';
    } else {
      note.textContent = '';
      bar.innerHTML = 'Showing: <strong>Standard Sizes</strong>';
    }
  }

  function doAllInPantyFind() {
    var input = wrap.querySelector('#sgInput');
    var area = wrap.querySelector('#sgResultArea');
    if (!input || !area) return;

    var val = input.value.trim();
    var num = parseInt(val, 10);

    lastSize = null;

    if (!val || isNaN(num) || num < 2 || num > 24) {
      area.innerHTML = '<div class="sg-result-error">Please enter a clothing size between 2 and 24</div>';
      buildAllInPantyTable();
      return;
    }

    if (num % 2 !== 0) num = num + 1;
    if (num > 24) num = 24;

    var base = PANTY_SIZE_MAP[num];
    if (!base) {
      area.innerHTML = '<div class="sg-result-error">Size not found - contact us for help!</div>';
      buildAllInPantyTable();
      return;
    }

    var final = shiftPantySize(base, adjust);
    lastSize = base;

    var sub = 'for pre-pregnancy clothing size ' + val;
    if (activeBtn === 'down') sub += ' - sized down for postpartum 3+ months';
    if (activeBtn === 'up1') sub += ' - sized up for postpartum 0-3 months';
    if (activeBtn === 'up2') sub += ' - sized up for pregnancy';

    area.innerHTML =
      '<div class="sg-result-label">Your recommended ' + guideName + ' size is</div>' +
      '<div class="sg-result-badge">' + final + '</div>' +
      '<div class="sg-result-sub">' + sub + '</div>';

    buildAllInPantyTable();
  }

  var btnUp1 = wrap.querySelector('#sgBtnUp1');
  var btnDown = wrap.querySelector('#sgBtnDown');
  var btnUp2 = wrap.querySelector('#sgBtnUp2');
  var allBtns = [btnUp1, btnDown, btnUp2].filter(Boolean);

  function clearAllInPantyBtns() {
    allBtns.forEach(function(btn) {
      btn.classList.remove('sg-active');
    });
  }

  if (btnUp1) {
    btnUp1.addEventListener('click', function () {
      if (activeBtn === 'up1') {
        adjust = 0;
        activeBtn = null;
        clearAllInPantyBtns();
      } else {
        adjust = 1;
        activeBtn = 'up1';
        clearAllInPantyBtns();
        btnUp1.classList.add('sg-active');
      }
      updateAllInPantyStatus();
      buildAllInPantyTable();
      if (lastSize) doAllInPantyFind();
    });
  }

  if (btnDown) {
    btnDown.addEventListener('click', function () {
      if (activeBtn === 'down') {
        adjust = 0;
        activeBtn = null;
        clearAllInPantyBtns();
      } else {
        adjust = -1;
        activeBtn = 'down';
        clearAllInPantyBtns();
        btnDown.classList.add('sg-active');
      }
      updateAllInPantyStatus();
      buildAllInPantyTable();
      if (lastSize) doAllInPantyFind();
    });
  }

  if (btnUp2) {
    btnUp2.addEventListener('click', function () {
      if (activeBtn === 'up2') {
        adjust = 0;
        activeBtn = null;
        clearAllInPantyBtns();
      } else {
        adjust = 1;
        activeBtn = 'up2';
        clearAllInPantyBtns();
        btnUp2.classList.add('sg-active');
      }
      updateAllInPantyStatus();
      buildAllInPantyTable();
      if (lastSize) doAllInPantyFind();
    });
  }

  var allInBtn = wrap.querySelector('#sgFindBtn');
  var allInInput = wrap.querySelector('#sgInput');

  if (allInBtn) {
    allInBtn.addEventListener('click', doAllInPantyFind);
  }

  if (allInInput) {
    allInInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') doAllInPantyFind();
    });
  }

  buildAllInPantyTable();
  updateAllInPantyStatus();
  return;
}
    if (config.type === 'panty') {
      function clearHighlight() {
        wrap.querySelectorAll('.sg-cell-highlight').forEach(function(el) {
          el.classList.remove('sg-cell-highlight');
        });
      }

      function doPantyFind() {
        var input = wrap.querySelector('#sgInput');
        var area = wrap.querySelector('#sgResultArea');
        if (!input || !area) return;

        var val = input.value.trim();
        var num = parseInt(val, 10);

        clearHighlight();

        if (!val || isNaN(num) || num < 2 || num > 24) {
          area.innerHTML = '<div class="sg-result-error">Please enter a clothing size between 2 and 24</div>';
          return;
        }

        if (num % 2 !== 0) num = num + 1;
        if (num > 24) num = 24;

        var size = config.SIZE_MAP[num];

        if (!size) {
          area.innerHTML = '<div class="sg-result-error">Size not found - contact us for help!</div>';
          return;
        }

        area.innerHTML =
          '<div class="sg-result-label">Your recommended size is</div>' +
          '<div class="sg-result-badge">' + size + '</div>' +
          '<div class="sg-result-sub">for pre-pregnancy clothing size ' + val + '</div>';

        var cell = wrap.querySelector('#cell-' + CSS.escape(size));
        if (cell) cell.classList.add('sg-cell-highlight');
      }

      var pantyBtn = wrap.querySelector('#sgFindBtn');
      var pantyInput = wrap.querySelector('#sgInput');

      if (pantyBtn) {
        pantyBtn.addEventListener('click', doPantyFind);
      }

      if (pantyInput) {
        pantyInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') doPantyFind();
        });
      }

      return;
    }

    var adjust = 0;
    var lastBand = null;
    var lastCup = null;

    function shiftSize(size, offset) {
      if (!size || offset === 0) return size;
      var i = SIZE_ORDER.indexOf(size);
      if (i === -1) return size;
      return SIZE_ORDER[Math.max(0, Math.min(SIZE_ORDER.length - 1, i + offset))];
    }

    function cellClass(size) {
      if (!size) return 'sg-cell-empty';
      var map = {
        'S': 'sg-cell-s',
        'M': 'sg-cell-m',
        'L': 'sg-cell-l',
        'XL': 'sg-cell-xl',
        '1X': 'sg-cell-xl',
        '2X': 'sg-cell-xl',
        '3X': 'sg-cell-xl'
      };
      return map[size] || 'sg-cell-m';
    }

    function buildTable() {
      var tbody = wrap.querySelector('#sgTbody');
      if (!tbody) return;
      tbody.innerHTML = '';

      BANDS.forEach(function (band) {
        var tr = document.createElement('tr');

        var tdB = document.createElement('td');
        tdB.className = 'sg-band';
        tdB.textContent = band;
        tr.appendChild(tdB);

        CUPS.forEach(function (cup) {
          var td = document.createElement('td');
          var base = BASE[band][cup];
          var display = base ? shiftSize(base, adjust) : null;

          td.textContent = display || '';
          td.className = cellClass(display);
          td.dataset.band = band;
          td.dataset.cup = cup;

          if (band === lastBand && cup === lastCup && base) {
            td.classList.add('sg-cell-highlight');
          }

          tr.appendChild(td);
        });

        tbody.appendChild(tr);
      });
    }

    function updateStatus() {
      var note = wrap.querySelector('#sgShiftNote');
      var bar = wrap.querySelector('#sgStatusBar');
      if (!note || !bar) return;

      if (adjust === -1) {
        note.textContent = 'Sizes shifted down - recommended if breastfeeding or postpartum.';
        bar.innerHTML = 'Showing: <strong>Sized Down - Breastfeeding / Postpartum</strong>';
      } else if (adjust === 1) {
        note.textContent = 'Sizes shifted up - recommended if pregnant or between sizes.';
        bar.innerHTML = 'Showing: <strong>Sized Up - Pregnant / In Between Sizes</strong>';
      } else {
        note.textContent = '';
        bar.innerHTML = 'Showing: <strong>Standard Sizes</strong>';
      }
    }

    function parseBraSize(raw) {
      var s = raw.trim().toUpperCase().replace(/\s/g, '');
      var pattern = guideType === 'do-anything'
        ? /^(\d{2})(DDD|DD|[A-F])$/
        : /^(\d{2})(DDDD|DDD|DD|[A-G])$/;

      var m = s.match(pattern);
      if (!m) return null;

      var aliases = { E:'DD', F:'DDD', G:'DDDD' };
      return { band: m[1], cup: aliases[m[2]] || m[2] };
    }

    function doFind() {
      var input = wrap.querySelector('#sgInput');
      var area = wrap.querySelector('#sgResultArea');
      if (!input || !area) return;

      var val = input.value;
      var parsed = parseBraSize(val);

      lastBand = null;
      lastCup = null;

      if (!parsed) {
        area.innerHTML = '<div class="sg-result-error">Please enter a valid bra size.</div>';
        buildTable();
        return;
      }

      var band = parsed.band;
      var cup = parsed.cup;

      if (BANDS.indexOf(band) === -1 || CUPS.indexOf(cup) === -1 || !BASE[band] || !BASE[band][cup]) {
        area.innerHTML = '<div class="sg-result-error">Unfortunately, we don’t currently carry this size.</div>';
        buildTable();
        return;
      }

      var base = BASE[band][cup];
      var final = shiftSize(base, adjust);

      lastBand = band;
      lastCup = cup;

      var sub = 'for bra size ' + val.toUpperCase();
      if (adjust === -1) sub += ' - sized down for breastfeeding/postpartum';
      if (adjust === 1) sub += ' - sized up for pregnancy/in-between';

      area.innerHTML =
        '<div class="sg-result-label">Your recommended ' + guideName + ' size is</div>' +
        '<div class="sg-result-badge">' + final + '</div>' +
        '<div class="sg-result-sub">' + sub + '</div>';

      buildTable();
    }

    var btnDown = wrap.querySelector('#sgBtnDown');
    var btnUp = wrap.querySelector('#sgBtnUp');
    var findBtn = wrap.querySelector('#sgFindBtn');
    var input = wrap.querySelector('#sgInput');

    if (btnDown) {
      btnDown.addEventListener('click', function () {
        if (adjust === -1) {
          adjust = 0;
          btnDown.classList.remove('sg-active');
        } else {
          adjust = -1;
          btnDown.classList.add('sg-active');
          if (btnUp) btnUp.classList.remove('sg-active');
        }
        updateStatus();
        buildTable();
        if (lastBand) doFind();
      });
    }

    if (btnUp) {
      btnUp.addEventListener('click', function () {
        if (adjust === 1) {
          adjust = 0;
          btnUp.classList.remove('sg-active');
        } else {
          adjust = 1;
          btnUp.classList.add('sg-active');
          if (btnDown) btnDown.classList.remove('sg-active');
        }
        updateStatus();
        buildTable();
        if (lastBand) doFind();
      });
    }

    if (findBtn) {
      findBtn.addEventListener('click', doFind);
    }

    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') doFind();
      });
    }

    buildTable();
    updateStatus();
  }

  window.initBodilySizeGuide = initSizeGuide;

  document.addEventListener('DOMContentLoaded', initSizeGuide);
  document.addEventListener('click', function () {
    setTimeout(initSizeGuide, 100);
  });
})();